module.exports = __webpack_public_path__ + "static/media/designer.3c5ac143.jpg";